<div class="flex flex-row flex-1 items-center gap-8">
  @if (userHasTwoFactorAuthEnabled()) {
    <div class="tfa-enabled-icon">
      <mat-icon svgIcon="icon_check_16" class="icon-16" />
    </div>
  }
  <div class="flex flex-col gap-4">
    <h3>
      Two-Factor Authentication is {{ userHasTwoFactorAuthEnabled() ? 'enabled' : 'disabled' }}
    </h3>
    @if (userHasTwoFactorAuthEnabled()) {
      <a (click)="onShowTwoFactorSetupDialog()">Edit</a>
    }
  </div>
</div>

<div class="flex gap-8">
  @if (userHasPasswordLogin()) {
    @if (!userHasTwoFactorAuthEnabled()) {
      <button
        (click)="onShowTwoFactorSetupDialog()"
        blazeButton="secondary"
        blazeButtonSize="lg"
        class="uppercase"
      >
        Enable
      </button>
    }
    @if (userHasTwoFactorAuthEnabled()) {
      <button
        (click)="onShowTwoFactorSetupDialog(true)"
        blazeButton="secondary"
        blazeButtonSize="lg"
        class="uppercase"
      >
        <mat-icon svgIcon="warning" class="account-warning-icon" />
        Disable
      </button>
    }
  }
</div>
